/*******************************************************************************
GET KEY DATA POINTS FOR CHART
This calculates the start, end, max and min data points from a chart's data set.
*******************************************************************************/

export default function getKeyChartistDataPoints(dataSets) {
    return dataSets.map((dataSet) => {
        const numData = dataSet.length;
        if (numData === 0) { return []; }

        const data = $.extend(true, [], dataSet);

        const maxEntry = data.reduce((max, d) => ((Number(d.value) >= Number(max.value)) ? d : max));
        const minEntry = data.reduce((min, d) => ((Number(d.value) < Number(min.value)) ? d : min));
        const start = data[0];
        const end = data[numData - 1];

        const keyPoints = [start, end];
        const keyValues = keyPoints.map(p => p.value);

        if (!keyValues.includes(minEntry.value)) { keyPoints.push(minEntry); }
        if (!keyValues.includes(maxEntry.value)) { keyPoints.push(maxEntry); }

        return keyPoints;
    });
}
